var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Key = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M15.031 9.34199C15.031 9.13499 14.863 8.96799 14.656 8.96799C14.449 8.96899 14.281 9.13699 14.281 9.34399C14.281 9.55099 14.449 9.71899 14.656 9.71799C14.863 9.71799 15.031 9.54999 15.031 9.34299M12.499 14.785L11.469 15.817H9.637V17.286H8.172V19.122L6.798 20.5H3.5V17.195L9.223 11.459C8.417 9.36499 8.849 6.90299 10.534 5.21399C12.814 2.92899 16.511 2.92899 18.791 5.21399C21.071 7.49899 21.071 11.204 18.791 13.49C17.089 15.194 14.601 15.624 12.499 14.785Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
